import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
export const ErrorWithIcon = ({ error, ml = 0, mt = 1 }) => {
    const { t } = useTranslation();
    if (!error || error === '') {
        return null;
    }
    return (_jsx(Box, { sx: { display: 'flex', alignItems: 'center', mt, width: '100%', ml }, children: _jsx(Typography, { variant: 'caption', color: 'error', children: error }) }));
};
